/**
 * ============================================================================
 * EnrollNowSticky — View (UI only)
 * ============================================================================
 */
"use client";

import styles from "../EnrollNowSticky.module.scss";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";
import clsx from "clsx";
import PhoneIconNew from "@/SvgIcons/PhoneIconNew";
import type { EnrollNowStickyViewModel } from "../model/enrollNowSticky.types";

export default function EnrollNowStickyView(vm: EnrollNowStickyViewModel) {
  const {
    isHomePage,
    isHomePageUrl,
    isHidden,
    useCounsellingCta,
    handleWhatsAppBtnClicked,
    downloadBrochureScneario,
    handleCallBtnClicked,
    handleTalkToCounsellor,
  } = vm;

  return (
    <div
      className={clsx(styles.root, { [styles.displayNone]: isHidden })}
      id="enroll-now-cta"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        boxSizing: "border-box",
        ...(isHidden ? { display: "none" } : null),
      }}
    >
      <div className={styles.container}>
        {isHomePage ? (
          isHomePageUrl ? (
            <button
              onClick={handleCallBtnClicked}
              className={`${styles.download_btn} ${styles.phone_icon_btn}`}
            >
              <PhoneIconNew color="#FFF" width={18} height={18} />
              Call Us
            </button>
          ) : (
            <button
              onClick={handleTalkToCounsellor}
              className={styles.download_btn}
              id="enroll_now_sticky_talk_to_counsellor"
            >
              Talk to a Counsellor
            </button>
          )
        ) : (
          <button
            onClick={downloadBrochureScneario}
            className={styles.download_btn}
            id="enroll_now_sticky_broucher"
          >
            <UnivoImage
              src={IMAGE_ASSETS.downloadWhiteArrowIcon}
              width={18}
              height={18}
              sizes="18px"
              alt="download brochure logo"
              className="mr-1"
              loading="lazy"
              fetchPriority="low"
              unoptimized
            />
            Download Brochure
          </button>
        )}
        {useCounsellingCta ? (
          <button
            onClick={handleTalkToCounsellor}
            className={`${styles.download_btn} ${styles.Counsellor_btn}`}
          >
            1-1 Counselling
          </button>
        ) : (
          <button
            className={styles.live_chat_btn}
            onClick={handleWhatsAppBtnClicked}
          >
            <UnivoImage
              src={IMAGE_ASSETS.whatsappIcon}
              width={18}
              height={18}
              sizes="18px"
              alt="download brochure logo"
              className="mr-1"
              loading="lazy"
              fetchPriority="low"
              unoptimized
            />
            Live Chat
          </button>
        )}
      </div>
    </div>
  );
}
